import { TOAST_MESSAGES } from "../constants";
import { useState } from "react";
import toast from "react-hot-toast";
import { addPayroll, getPayroll, deletePayroll, getPayrollById, updatePayroll, getSalarySlips, getSalarySlipById ,updateSalarySlips, run_payroll, notifyDownloadSlips, } from "../../../Services/payrollServices";
import { RESET_PAGINATION } from "../../../Constants/Strings";
import { extractErrorMessage } from "../../../Utils/extractErrorMessage";

export const usePayroll = () => {
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({
        user: null,
    });

    const [pagination, setPagination] = useState(RESET_PAGINATION);
    const [payroll, setPayroll] = useState([]);

    const fetchPayroll = async (params) => {
        setLoading(true);
        try {
            const response = await getPayroll({
                ...filters,
                ...params,
                limit: params?.limit ?? pagination.limit,
                offset: params?.offset ?? pagination.offset,
            });
            if (response.status === 200) {
                const results = response.data?.results || [];

                setPagination({
                    limit: pagination.limit,
                    offset: response.data.offset ?? 0,
                    count: response.data.count ?? 0,
                });
                return results;
            }
        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.PAYROLL_FETCH_FAILED
            );
        } finally {
            setLoading(false);
        }
        return [];
    };

    const loadMorePayroll = async () => {
        if (pagination.offset >= pagination.count) return;

        const data = await fetchPayroll({ offset: pagination.offset });
        setPayroll(prev => [...prev, ...data]);
    };

    const createPayroll = async (formData) => {
        setLoading(true);

        try {
            const response = await addPayroll(formData);

            if (response.status === 201 || response.status === 200) {
                toast.success(TOAST_MESSAGES.PAYROLL_CREATED);
                return true;
            } else {
                toast.error(TOAST_MESSAGES.PAYROLL_CREATE_FAILED);
                return false;
            }

        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.PAYROLL_CREATE_FAILED
            );
            return false;
        } finally {
            setLoading(false);
        }
    };

    const removePayroll = async (id) => {
        setLoading(true);
        let success = false;
        try {
            const response = await deletePayroll(id);
            if (response.status === 204) {
                toast.success(TOAST_MESSAGES.SUCCESS_DELETE_PAYROLL);
                success = true;
            } else {
                const msg =
                    extractErrorMessage(response) || TOAST_MESSAGES.FAILED_DELETE_PAYROLL;
                toast.error(msg);
            }
        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.ERROR_DELETE_PAYROLL
            );
        } finally {
            setLoading(false);
            return success;
        }
    };

    const fetchPayrollById = async (id) => {
        setLoading(true);
        var data = null;
        try {
            const response = await getPayrollById(id);
            if (response.status === 200) {
                data = response.data;
            } else {
                const msg =
                    extractErrorMessage(response) ||
                    TOAST_MESSAGES.PAYROLL_FETCH_FAILED;
                toast.error(msg);
            }
        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.PAYROLL_FETCH_FAILED
            );
        } finally {
            setLoading(false);
            return data;
        }
    };

    const updatePayrollMaster = async (payrollId, payload) => {
        setLoading(true);
        var data = null;
        try {
            const response = await updatePayroll(payrollId, payload);
            if (response.status === 200) {
                data = response.data;
                const msg = TOAST_MESSAGES.UPDATE_PAYROLL_SUCCESS;
                toast.success(msg);
            } else {
                const msg =
                    extractErrorMessage(response) ||
                    TOAST_MESSAGES.UPDATE_PAYROLL_FAILED;
                toast.error(msg);
            }
        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.UPDATE_PAYROLL_FAILED
            );
        } finally {
            setLoading(false);
            return data;
        }
    };

    const fetchSalarySlips = async (params) => {
        setLoading(true);
        try {
            const response = await getSalarySlips({
                ...filters,
                ...params,
                limit: params?.limit ?? pagination.limit,
                offset: params?.offset ?? pagination.offset,
            });
            if (response.status === 200) {
                const results = response.data?.results || response.data || [];

                setPagination({
                    limit: pagination.limit,
                    offset: response.data.offset ?? 0,
                    count: response.data.count ?? 0,
                });
                return results;
            }
        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.SALARY_SLIPS_FETCH_FAILED
            );
        } finally {
            setLoading(false);
        }
        return [];
    };

    const loadMoreSalarySlips = async () => {
        if (pagination.offset >= pagination.count) return;

        const data = await fetchSalarySlips({ offset: pagination.offset });
        setPayroll(prev => [...prev, ...data]);
    };

    const fetchSalarySlipById = async (id) => {
        setLoading(true);
        var data = null;
        try {
            const response = await getSalarySlipById(id);
            if (response.status === 200) {
                data = response.data;
            } else {
                const msg =
                    extractErrorMessage(response) ||
                    TOAST_MESSAGES.SALARY_SLIPS_FETCH_FAILED;
                toast.error(msg);
            }
        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.SALARY_SLIPS_FETCH_FAILED
            );
        } finally {
            setLoading(false);
            return data;
        }
    };

    const updateSalarySlip = async (slipId, payload, options = {}) => {
        setLoading(true);
        var data = null;
        try {
            const finalPayload = { ...payload };
            if (options.action) {
                finalPayload.action = options.action;
            }
            const response = await updateSalarySlips(slipId, finalPayload);
            if (response.status === 200) {
                data = response.data;
                const msg = TOAST_MESSAGES.UPDATE_SALARY_SLIP_SUCCESS;
                toast.success(msg);
            } else {
                const msg =
                    extractErrorMessage(response) ||
                    TOAST_MESSAGES.UPDATE_SALARY_SLIP_FAILED;
                toast.error(msg);
            }
        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.UPDATE_SALARY_SLIP_FAILED
            );
        } finally {
            setLoading(false);
            return data;
        }
    };

    const addSalarySlip = async ({ month }) => {
        setLoading(true);

        try {
            const response = await run_payroll({ month });
            if (response.status === 200) {
                toast.success(TOAST_MESSAGES.SALARY_SLIPS_FETCH);
                return true;
            } else {
                toast.error(TOAST_MESSAGES.SALARY_SLIPS_FETCH_FAILED);
                return false;
            }

        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.SALARY_SLIPS_FETCH_FAILED
            );
            return false;
        } finally {
            setLoading(false);
        }
    };

    const notifyDownloadSalarySlip = async (id) => {
        setLoading(true);
        var data = null;
        try {
            const response = await notifyDownloadSlips(id);
            if (response.status === 200) {
                data = response.data;
            } else {
                const msg =
                    extractErrorMessage(response) ||
                    TOAST_MESSAGES.NOTIFICATION_FAILED;
                toast.error(msg);
            }
        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.NOTIFICATION_FAILED
            );
        } finally {
            setLoading(false);
            return data;
        }
    };

    return {
        loading,
        filters,
        setFilters,
        pagination,
        setPagination,
        fetchPayroll,
        loadMorePayroll,
        pagination,
        payroll,
        setPayroll,
        createPayroll,
        removePayroll,
        fetchPayrollById,
        updatePayrollMaster,
        fetchSalarySlips,
        loadMoreSalarySlips,
        fetchSalarySlipById,
        updateSalarySlip,
        addSalarySlip,
        notifyDownloadSalarySlip
    };
};